import { render } from "./QuickNavLink.vue?vue&type=template&id=23154134"
import script from "./QuickNavLink.vue?vue&type=script&lang=js"
export * from "./QuickNavLink.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__